import roundedRectangle from './rounded-rectangle';

const defaultWidth = 200;
const defaultHeight = 40;
const defaultTextColour = 0xFFFFFF;

export default function({ text, bgColour, width, height, textColour }) {
  width = width || defaultWidth;
  height = height || defaultHeight;
  textColour = typeof textColour === 'number' ? textColour : defaultTextColour;

  const btn = new PIXI.Sprite();
  btn.cursor = 'pointer';

  Object.defineProperty(btn, 'enabled', {
    set: val => {
      btn.alpha = val ? 1 : 0.3;
      btn.interactive = val;
    }
  });

  btn.enabled = true;

  const rect = roundedRectangle({
    x: -width / 2,
    y: -height / 2,
    w: width,
    h: height,
    r: 4,
    fillColour: bgColour
  });
  btn.addChild(rect);

  btn.label = new PIXI.Text(text, {
    font: '15px Open Sans, Arial',
    fill: textColour,
    align: 'center',
    letterSpacing: 1
  });
  btn.addChild(btn.label);
  btn.label.anchor.set(0.5);

  return btn;
};
